import { LoginMethod } from "../../../components/Authentication/LoginMethods/types";
import {
  RegionalInstanceCapability,
  type RegionalInstanceConfig,
} from "./regional-instance-types";

export const REGIONAL_INSTANCE_CONFIG: RegionalInstanceConfig = {
  global: {
    endpoints: {
      api: "https://api.wooting.io",
      cdn: "https://wooting-website.ams3.cdn.digitaloceanspaces.com",
      store: "https://wooting.io",
    },
    capabilities: {
      [RegionalInstanceCapability.Discord]: true,
      [RegionalInstanceCapability.PhoneOTP]: false,
      [RegionalInstanceCapability.ChangeLocale]: true,
    },
    login: {
      methods: [LoginMethod.EmailAndPassword],
      default: LoginMethod.EmailAndPassword,
    },
  },
  cn: {
    endpoints: {
      api: "https://api.wooting.com.cn",
      cdn: "https://images.wooting.com.cn",
      store: "https://wooting.com.cn",
    },
    capabilities: {
      [RegionalInstanceCapability.Discord]: false,
      [RegionalInstanceCapability.PhoneOTP]: true,
      [RegionalInstanceCapability.ChangeLocale]: false,
    },
    login: {
      methods: [LoginMethod.PhoneOTP],
      default: LoginMethod.PhoneOTP,
    },
  },
};
